import React, { useCallback, useMemo } from "react";
import styles from "./Style.module.css";
import constants from "../../../../config/constants";
import DataTables from "../../../../Datatables/Datatable.table";
import classNames from "classnames";
import useAppProgramsTable from "./AppProgramsTable.hook";
import capitalizeFirstLetter from "../../../../hooks/CommonFunction";
import StatusPill from "../../../../components/Status/StatusPill.component";
import ShadowBox from "../../../../components/ShadowBox/ShadowBox";
import FilterComponent from "../../../../components/Filter/Filter.component";
import { Typography } from "@mui/material";
const AppProgramsTable = ({ listData }) => {
  const {
    handleSortOrderChange,
    handleRowSize,
    handlePageChange,
    isCalling,
    data,
    currentData,
    currentPage,
    isFetching,
    isDialog,
    toggleDialog,
    editData,
    handleSearchValueChange,
    handleFilterDataChange,
    configFilter,
    handleProgramClick
  } = useAppProgramsTable({ listData });

  const renderFirstCell = useCallback((user) => {
    return (
      <div className={styles.firstCellFlex}>
        <div className={classNames(styles.firstCellInfo, "openSans")}>
          <div>{`${capitalizeFirstLetter(user?.name)}`} </div>
        </div>
      </div>
    );
  }, []);

  const renderStatus = useCallback((status) => {
    if (status === "ACTIVE") {
      return <StatusPill status={"Active"} color={"active"} />;
    } else if (status === "INACTIVE") {
      return <StatusPill status={"Inactive"} color={"high"} />;
    }
  }, []);

  const tableStructure = useMemo(
    () => [
      {
        key: "program",
        label: "Program Name",
        sortable: false,
        render: (temp, all) => (
          <div className={styles.titleCont}><Typography color={"primary"} className={styles.program} onClick={(e) => {
            e.stopPropagation();
            handleProgramClick(all);
          }}>{capitalizeFirstLetter(all?.name)}</Typography></div>
        ),
      },

      {
        key: "client",
        label: "Client",
        sortable: false,
        render: (temp, all) => <div>{capitalizeFirstLetter(all?.client?.name)}</div>,
      },
      {
        key: "enrolled",
        label: "Enrolled On",
        sortable: false,
        render: (temp, all) => <div>{all?.createdAtText}</div>,
      },
      {
        key: "pet",
        label: "Pet Condition",
        sortable: false,
        render: (temp, all) =>{const conditionMapping ={
          10: "10 - Sick",
          20: "20 - Stable",
          30: "30 - Healthy",

        }; return <div>{conditionMapping[all?.pet_current_state] || all?.pet_current_state}</div>}
      },
      {
        key: "status",
        label: "Status",
        sortable: false,
        render: (temp, all) => <div>{renderStatus(all.status)}</div>,
      },
    ],
    [renderFirstCell, toggleDialog]
  );

  const tableData = useMemo(() => {
    const datatableFunctions = {
      onSortOrderChange: handleSortOrderChange,
      onPageChange: handlePageChange,
      onRowSizeChange: handleRowSize,
    };

    const datatable = {
      ...constants.DATATABLE_PROPERTIES,
      columns: tableStructure,
      data: currentData,
      count: data.length,
      page: currentPage - 1,
      rowsPerPage: 10,
      allRowSelected: false,
      showSelection: false,
    };

    return { datatableFunctions, datatable };
  }, [
    tableStructure,
    handleSortOrderChange,
    handlePageChange,
    handleRowSize,
    currentData,
    currentPage,
    data,
  ]); // allData,

  return (
    <ShadowBox className={styles.mainContainer}>
      <FilterComponent
         is_progress={isFetching}
         filters={configFilter}
        handleSearchValueChange={handleSearchValueChange}
         handleFilterDataChange={handleFilterDataChange}
         placeholder="Search by program name"
      />
      <br />
      <DataTables {...tableData.datatable} {...tableData.datatableFunctions} />
    </ShadowBox>
  );
};

export default AppProgramsTable;
